<h2 mat-dialog-title>{{ "demo.invite.title" | translate }}</h2>
<mat-dialog-content>
  <p>{{ "demo.invite.body" | translate }}</p>
  <div class="qrcode-wrapper">
    <qrcode
      [qrdata]="data.link"
      [width]="200"
      [errorCorrectionLevel]="'M'"
    ></qrcode>
  </div>
  <div class="link-wrapper">
    <button type="button" class="button outlined-button" (click)="copyLink()">
      {{ "demo.invite.copyLabel" | translate }}
    </button>
    @if (copied()) {
      <p class="copied-hint">{{ "demo.invite.copied" | translate }}</p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="button"
    class="button full-width primary-button"
    mat-dialog-close
  >
    {{ "default.ok" | translate }}
  </button>
</mat-dialog-actions>
